import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import "rxjs/add/operator/map";

import { Observable } from "rxjs";

import { API_URL } from "./token.service";

@Injectable()
export class _AuthenticationService {
  private AUTH_TOKEN: string;
  public TOKEN: Observable<any>;

  constructor(private http: HttpClient) {}

  login(username: string, password: string) {
    document.cookie = "SESSION=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    let headers: any = new HttpHeaders({
      Authorization: "Basic " + btoa(username + ":" + password),
    });

    const subscription = this.http.post(`${API_URL}/authenticate`, "{}", {
      headers: headers,
    });

    return subscription;
    // if((username==='admin@wisetradingtech.com' || username==='user@wisetradingtech.com') && password==='Password123') {
    //
    //   localStorage.setItem(ACTIVE_USER, username);
    //   this.AUTH_TOKEN = 'Basic ' + btoa(username + ':' + password);
    //   return this.AUTH_TOKEN;
    // } else {
    //   return null;
    // }
  }

  resetPassword(email: string) {
    return this.http.post(`${API_URL}/users/reset-password`, { email });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/auth.service.ts